export const browser = {
  getHostname: () => {
    return window.location.hostname;
  },
  getLocation: () => {
    return window.location;
  },
  redirect: (url: string) => {
    window.location.href = url;
  },
  setLocalStorageItem: (key: string, value: string) => {
    localStorage.setItem(key, value);
  },
  getLocalStorageItem: (key: string) => {
    return localStorage.getItem(key);
  },
};
